import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const problems = [{
  tag: '😩 Problem #1',
  title: '„Mir ist langweilig!“ — immer wieder',
  text: 'Selbst mit einem Zimmer voller Spielzeug. Selbst direkt nach dem Kauf von etwas Neuem. Die Langeweile-Schleife endet nie und dir gehen die Ideen aus.',
  img: 'https://cdn.magicpatterns.com/uploads/ihjE7DKY1ufhoEJhsEe429/IMG_1064.webp',
  alt: 'Weinendes Kleinkind neben Spielzeug'
}, {
  tag: '📱 Problem #2',
  title: 'Bildschirme. Den ganzen Tag. Jeden Tag.',
  text: 'Du gibst ihnen ein Tablet „nur kurz“ und zwei Stunden später kleben sie immer noch daran. Nichts fesselt sie so wie ein Bildschirm — und du hasst es.',
  img: 'https://cdn.magicpatterns.com/uploads/iF8QAP4AAhfEAASdSCwhT5/IMG_1063.webp',
  alt: 'Frustrierter Junge starrt auf ein Tablet'
}, {
  tag: '😤 Problem #3',
  title: 'Du hast alles versucht — nichts bleibt hängen',
  text: 'Bastelsets, Puzzles, Outdoor-Aktivitäten… sie halten einen Nachmittag. Du gibst ständig Geld und Energie aus, und nichts hält sie länger als einen Tag bei der Sache.',
  img: 'https://cdn.magicpatterns.com/uploads/wLtfrSPqS9mi15yuLtP3pw/IMG_1062.webp',
  alt: 'Zwei Jungen versteckt hinter ihren Handys'
}, {
  tag: '😭 Problem #4',
  title: 'Der Wutanfall, wenn der Bildschirm weg ist',
  text: 'Jedes Mal, wenn du die Bildschirmzeit begrenzt, wird es zum Kampf. Tränen, Trotzanfälle, Verhandeln. Du fühlst dich wie der Böse — obwohl du nur das Richtige tun willst.',
  img: 'https://cdn.magicpatterns.com/uploads/by9pMNhj1jGZXhdizermvD/IMG_1065.webp',
  alt: 'Weinendes Mädchen neben Teddybär'
}];
export function Problems() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-143" data-mp="3iot9n3nadiow">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-144" data-mp="aako2fj6ls68">
        <SectionHeading eyebrow="Kommt dir das bekannt vor?" title="Kennst du das auch?" subtitle="Jedes Elternteil kennt das. Du willst deine Kinder weg vom Bildschirm und mit etwas Echtem beschäftigt — aber nichts scheint lange zu funktionieren." data-id="element-145" data-mp="a8zuas4oyd9f" />
        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-146" data-mp="ktts3od3ob1i">
          {problems.map((p, i) => <motion.article key={p.tag} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="flex flex-col overflow-hidden rounded-3xl border border-ink/10 bg-cream" data-id="element-147" data-mp="fyy20trfbxr1" data-mpi={i}>
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-148" data-mp="3jc8uwbcw7bty">
                <img src={p.img} alt={p.alt} className="h-full w-full object-cover" data-id="element-149" data-mp="3edyyxyjcg77a" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-150" data-mp="34cwq4qph3nh9">
                <span className="mb-3 w-fit rounded-full bg-brand-light px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-151" data-mp="398bwkxl5ih3n">
                  {p.tag}
                </span>
                <h3 className="font-display text-xl font-bold text-ink" data-id="element-152" data-mp="3j6rsddv4iejh">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-153" data-mp="2llm00brkneqf">
                  {p.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}